// PERMISSIONS_DISABLED: Permisos desactivados temporalmente.
// Todos los selectores devuelven true para que cualquier usuario vea todo.
// Para reactivar: descomentar el bloque original de abajo y eliminar el stub.
export const createPermissionSelectors = (_state) => {
  const allow = () => true;
  return {
    can: allow,
    canAny: allow,
    canAll: allow,
    hasPermission: allow,
    hasAnyPermission: allow,
    hasAllPermissions: allow,
    hasModuleAccess: allow,
    hasAnyModuleAccess: allow,
    hasAllModuleAccess: allow,
    hasConfigSectionPermission: allow,
  };
};

// PERMISSIONS_DISABLED: implementación real — descomentar para reactivar.
/*
export const createPermissionSelectors = ({
  permissions,
  permissionCodes,
  groupedPermissions,
}) => {
  const can = (permissionId) =>
    permissions instanceof Set && permissions.has(permissionId);

  const canAny = (permissionIds = []) =>
    permissions instanceof Set &&
    permissionIds.some((id) => permissions.has(id));

  const canAll = (permissionIds = []) =>
    permissions instanceof Set &&
    permissionIds.every((id) => permissions.has(id));

  const hasPermission = (code) =>
    typeof code === 'string' &&
    permissionCodes instanceof Set &&
    permissionCodes.has(code);

  const hasAnyPermission = (codes = []) =>
    permissionCodes instanceof Set &&
    codes.some((code) => permissionCodes.has(code));

  const hasAllPermissions = (codes = []) =>
    permissionCodes instanceof Set &&
    codes.every((code) => permissionCodes.has(code));

  const hasModuleAccess = (moduleKey) => {
    if (!moduleKey || typeof moduleKey !== 'string') return false;

    const module = groupedPermissions?.[moduleKey];
    if (!module || typeof module !== 'object') return false;

    const modulePermissions = module.permissions;
    if (!modulePermissions || typeof modulePermissions !== 'object') {
      return false;
    }

    return Object.values(modulePermissions).some((permission) => {
      return permission?.allowed === true;
    });
  };

  const hasAnyModuleAccess = (moduleKeys = []) =>
    Array.isArray(moduleKeys) &&
    moduleKeys.some((module) => hasModuleAccess(module));

  const hasAllModuleAccess = (moduleKeys = []) =>
    Array.isArray(moduleKeys) &&
    moduleKeys.every((module) => hasModuleAccess(module));

  const hasConfigSectionPermission = (code) =>
    typeof code === 'string' &&
    permissionCodes instanceof Set &&
    permissionCodes.has(code);

  return {
    can,
    canAny,
    canAll,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasModuleAccess,
    hasAnyModuleAccess,
    hasAllModuleAccess,
    hasConfigSectionPermission,
  };
};
*/
